export const colors = {
  yellow: '#faa40f',
  black: '#0d0d0d',
  white: '#fff',
  gray: '#d0d7de',
  lightGray: '#c9c9c9',
  chrome: '#6e7781',
};

export const fonts = {
  monospace: 'Menlo, monospace',
};

export const fontSizes = {
  xs: '0.75rem',
  sm: '0.875rem',
  md: '1rem',
  lg: '1.125rem',
  xl: '1.25rem',
};

export const fontWeights = {
  light: 300,
  normal: 400,
  bold: 700,
};
